import { WorkOrderStatus } from "@/gql/graphql";
import { useGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { workOrderStatusCountQuery } from "@/app/ProDrivers/WorkOrders/GraphQL/WorkOrderStatusCountQuery";
import { SidebarPulseIndicator } from "@/lib/Components/Layout/Sidebar/SidebarPulseIndicator";
import { useTenant } from "@/app/Organisations/Hooks/useTenant";
import { useGlobalSupplier } from "@/app/Suppliers/Utils/useGlobalSupplier";

export function WorkOrdersNotificationIndicator() {
  const { isAdmin } = useTenant();
  const { supplierId } = useGlobalSupplier();
  const { data: statusCountData } = useGqlQuery(workOrderStatusCountQuery, {
    supplier_id: supplierId,
  });

  const getCount = (status: WorkOrderStatus) =>
    statusCountData?.workOrderStatusCount.find((s) => s.status === status)
      ?.count ?? 0;

  if (isAdmin) {
    const quoteRequestedCount = getCount(WorkOrderStatus.QuoteRequested);
    const assigningDriversCount = getCount(WorkOrderStatus.AssigningDrivers);
    const totalCount = quoteRequestedCount + assigningDriversCount;

    const tooltipParts = [];
    if (quoteRequestedCount > 0) {
      tooltipParts.push(
        `${quoteRequestedCount} quote${quoteRequestedCount === 1 ? "" : "s"} requested`,
      );
    }
    if (assigningDriversCount > 0) {
      tooltipParts.push(`${assigningDriversCount} awaiting driver assignment`);
    }

    return (
      <SidebarPulseIndicator
        count={totalCount}
        color="yellow"
        tooltip={tooltipParts.join(", ")}
      />
    );
  }

  const quoteIssuedCount = getCount(WorkOrderStatus.QuoteIssued);

  return (
    <SidebarPulseIndicator
      count={quoteIssuedCount}
      color="blue"
      tooltip={`${quoteIssuedCount} quote${quoteIssuedCount === 1 ? "" : "s"} awaiting approval`}
    />
  );
}
